<template>
  <v-container fluid>
    <v-toolbar dense color="transparent" flat>
      <v-toolbar-title class="grey--text text--darken-2">
        <v-subheader>
          Empleados <v-icon>mdi-chevron-right</v-icon> Reporte de propinas
        </v-subheader>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-title class="text-h4 primary--text">{{ total | toCurrency }}</v-toolbar-title> -->
      <v-btn icon @click="openDrawer()">
        <v-icon>mdi-filter-cog</v-icon>
      </v-btn>
      <v-btn v-print="'#tipTable'" icon>
        <v-icon>mdi-printer</v-icon>
      </v-btn>
      <download-excel :name="'tip'" :before-generate="beforeDownload" :data="dataExcel">
        <v-btn icon>
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </download-excel>
    </v-toolbar>
    <v-row>
      <v-col>
        <TipTable ref="TipTable" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TipTable from '@/components/Employee/Tip/TipTable.vue'
export default {
  components: { TipTable },
  data: () => ({
    dataExcel: [],
    total: 0,
  }),
  methods: {
    beforeDownload() {
      this.dataExcel = this.$refs.TipTable.items
    },
    openDrawer() {
      this.$refs.TipTable.openDrawer()
    },
  },
}
</script>